import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { useModal } from '../contexts/ModalContext';
import BookingPopup from './BookingPopup';

export default function Header({ openFullscreenMenu }) {
  const [isScroll, setIsScroll] = useState(false);
  const [showSerachEngine, setshowSerachEngine] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial check in case the user already scrolled
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div className="main-header">
        <header className="header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-6 col-sm-4 col-md-4">
                <div className="header-logo">
                  <Link to={"/"}>
                    <img src="/assets/images/header-logo.webp" alt="Logo" className='img-responsive' />
                  </Link>
                </div>
              </div>
              <div className="col-6 col-sm-8 col-md-8">
                <div className="header-menu">
                  <nav className="header-menu-items" aria-label="Primary navigation">
                    <ul className="header-menus">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about-us/">About</Link></li>
                      <li><Link to="how-to-book-a-bin/"> How it Works?</Link></li>
                      <li className="dropdwon_menu"><Link  >Services <i className="fa-solid fa-chevron-down"></i></Link>
                        <ul className="dropdwon-sub">
                          <li><Link to="/residential-dumpsters-edmonton/">Residential Dumpsters</Link></li>
                          <li><Link to="/construction-dumpsters-edmonton/">Construction Dumpsters</Link></li>
                          <li><Link to="/commercial-dumpster-edmonton/">Commercial Dumpsters</Link></li>
                          {/* <li><Link to="/general-dumpster-edmonton/">General Dumpsters</Link></li> */}
                          <li><Link to="/other-services/" >Other Services</Link></li>
                        </ul>
                      </li>
                      <li><Link to="/pricing/" >Pricing</Link></li>
                      <li><Link to="/contact-us/">Contact</Link></li>
                    </ul>
                  </nav>
                  <div className="header-btn">
                    <Link onClick={() => setshowSerachEngine(true)} className="theme-btn"> <span className="color-overlay"></span> <span className="btn-txt">Book A Bin</span></Link>


                  </div>
                  <div className="humburger-menu">
                    <div onClick={() => window.openFullscreenMenu()} className="menu-trigger">
                      <div id="nav-icon1">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  )
}
